<template>
    <div data-page class="flex flex-col flex-1">
        <Banner v-if="!isArticleType" />

        <template v-if="isArticleType">
            <component :is="articleHeaderComponent" />
        </template>

        <Blocks />

        <template v-if="isArticleType">
            <component :is="articleFooterComponent" />
        </template>

        <div class="mt-auto">
            <PreFooter />
        </div>

        <Popup />
    </div>
</template>

<script setup>
    const entryStore = useEntryStore()
    const globalStore = useGlobalStore()

    const { entry, seomatic } = storeToRefs(entryStore)
    const { uri } = storeToRefs(globalStore)

    const articleTypes = ref(['ds_News_Entry', 'ds_Events_Entry'])

    const isArticleType = computed(() => {
        return articleTypes.value.includes(entry.value?.__typename)
    })

    // load page data
    await entryStore.loadEntry(uri.value)

    const articleHeaderComponent = defineAsyncComponent(() => {
        if (!isArticleType.value) {
            return
        }

        let name = entry.value.__typename

        // remove _ds and _Entry from the name
        name = replace(name, 'ds_', '')
        name = replace(name, '_Entry', '')

        return import(`~/components/article-types/${name}/header.async.vue`)
    })

    const articleFooterComponent = defineAsyncComponent(() => {
        if (!isArticleType.value) {
            return
        }

        let name = entry.value.__typename

        // remove _ds and _Entry from the name
        name = replace(name, 'ds_', '')
        name = replace(name, '_Entry', '')

        return import(`~/components/article-types/${name}/footer.async.vue`)
    })

    const seoTitle = computed(() => {
        const titleContainer = JSON.parse(seomatic.value?.metaTitleContainer ?? '{}')
        return get(titleContainer, 'title.title', entry.value?.title)
    })

    const metaTags = computed(() => {
        return flatMap(JSON.parse(seomatic.value?.metaTagContainer ?? '[]'))
    })

    useSeoMeta({
        title: seoTitle.value,
    })

    useHead({
        meta: metaTags.value
    })

</script>
